export const GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE = 'GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE';
export const GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_SUCCESS = `${GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE}/SUCCESS`;
export const GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_FAILURE = `${GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE}/FAILURE`;

export const SET_CONTACT_BATCH_MODE = 'SET_CONTACT_BATCH_MODE';

export default {
  GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE,
  GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_SUCCESS,
  GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_FAILURE,
  SET_CONTACT_BATCH_MODE
};
